import React from 'react';
import Link from '../../common/components/Link/Link';
import { LinkTypes } from '../../common/components/Link/link-types';
import Logo from '../../common/components/Logos/Logo';
var Box = function (_a) {
    var title = _a.title, description = _a.description, tags = _a.tags, image = _a.image, imageSize = _a.imageSize, url = _a.url;
    return (React.createElement(Link, { href: url, type: LinkTypes.BUTTON },
        React.createElement("div", { className: 'box__container' },
            React.createElement("div", { className: 'box__title-container' },
                React.createElement(Logo, { size: imageSize, image: image }),
                React.createElement("div", { className: 'box__title' }, title)),
            React.createElement("div", { className: 'box__description' }, description),
            React.createElement("div", { className: 'box__tags' }, tags.map(function (tag) { return React.createElement("div", { key: tag, className: 'box__tag' }, tag); })))));
};
export default Box;
